<template>
  <div>
    <!--INIT HIDDEN MODAL Selector -->
    <modal ref="sensorModal" :title="modalTitle" :location="location"/>
    <!--END HIDDEN MODAL Selector -->

    <b-row>
      <!-- INIT Parametros de resumen -->
      <b-col>
        <!-- Titulo -->
        <p>Datos de la zona geográfica</p>
        <div class="groupBox" style="min-height:300px;padding:20px">
          <b-row>
            <b-col cols="5">
              <b-form-group
                label="Alias de zona:"
                label-size="sm"
                label-class="font-weight-bold"
                class="form-location-label"
              />
            </b-col>
            <b-col>
              <span class="form-location-field-text">{{ location.alias }}</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="5">
              <b-form-group
                label="Tipología:"
                label-size="sm"
                label-class="font-weight-bold"
                class="form-location-label"
              />
            </b-col>
            <b-col>
              <span class="form-location-field-text">{{ location.type.name }}</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="5">
              <b-form-group
                label="Provincia:"
                label-size="sm"
                label-class="font-weight-bold"
                class="form-location-label"
              />
            </b-col>
            <b-col>
              <span class="form-location-field-text">{{
                location.location.province
              }}</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="5">
              <b-form-group
                label="Código Postal:"
                label-size="sm"
                label-class="font-weight-bold"
                class="form-location-label"
              />
            </b-col>
            <b-col>
              <span class="form-location-field-text">{{
                location.location.zip
              }}</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="5">
              <b-form-group
                label="Latitud:"
                label-size="sm"
                label-class="font-weight-bold"
                class="form-location-label"
              />
            </b-col>
            <b-col>
              <span class="form-location-field-text">{{
                location.location.latitude
              }}</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="5">
              <b-form-group
                label="Longitud:"
                label-size="sm"
                label-class="font-weight-bold"
                class="form-location-label"
              />
            </b-col>
            <b-col>
              <span class="form-location-field-text">{{
                location.location.longitude
              }}</span>
            </b-col>
          </b-row>       
        </div>
      </b-col>
      <!-- END Parametros de resumen -->
      <!-- INIT Parametros alertas -->      
      <b-col>
        <!-- Titulo -->
        <p>Datos analizados relevantes</p>        
        <div class="groupBox" style="min-height:300px;padding:20px">
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Último sismo:"
                label-size="sm"
                label-class="font-weight-bold"
                class="form-location-label"
              />
            </b-col>
            <b-col>
              <span class="form-location-field-text">{{ lastQuake }}</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Sismo más intenso:"
                label-size="sm"
                label-class="font-weight-bold"
                class="form-location-label"
              />
            </b-col>
            <b-col>
              <span class="form-location-field-text">{{ strongestQuake }}</span>
            </b-col>
          </b-row>

          <!-- LLUVIA ELIMINADA
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Última lluvia:"
                label-size="sm"
                label-class="font-weight-bold"
                class="form-location-label"
              />
            </b-col>
            <b-col>
              <span class="form-location-field-text">{{ lastRain }}</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Lluvia más intensa:"
                label-size="sm"
                label-class="font-weight-bold"
                class="form-location-label"
              />
            </b-col>
            <b-col>
              <span class="form-location-field-text">{{ strongestRain }}</span>
            </b-col>
          </b-row>
          -->

          <b-row>
            <b-col md="6">
              <b-form-group
                label="Sensores con alarmas:"
                label-size="sm"
                label-class="font-weight-bold"
                class="form-location-label"
              />
            </b-col>
            <b-col>
              <div>
                <img
                  style="margin-right: 20px"
                  class="botonAyuda"
                  title="Sensores con alerta activa"
                  :src="getImgUrl('eye.svg')"
                  @click="showSensorModal()"
                />
              </div>
            </b-col>
          </b-row>

        </div>
      </b-col>
      <!-- END Parametros de alertas -->      
    </b-row>
  </div>
</template>


<script>
import Spacer from "@/components/card/Spacer";
import Input from "@/components/common/form/Input";
import SensorModal from "@/components/groups/SensorModal";
import UserService from "@/services/UserService";
import GroupService from "@/services/GroupService";

export default {
  name: "edit-location-device",
  props: ["location"],
  data() {
    return {
      lastQuake: "",
      strongestQuake: "",
      lastRain: "",
      strongestRain: "",
      modalTitle: ""
     };
  },
  methods: {
    isUserAdmin() {
      return UserService.isUserAdmin();
    },

    retrieveSummaryData() {
      GroupService.getSummaryData(this.location._id)
      .then(response => {
        // Rellenamos los datos del resumen. Si falta alguno (null) lo rellenamos con "Sin datos"
        let summaryData = response.data;

        if (summaryData.quakeInfo) {
          this.lastQuake = summaryData.quakeInfo.lastQuake;
          this.strongestQuake = summaryData.quakeInfo.strongestQuake;
        } else {
          this.lastQuake = "Sin datos"
          this.strongestQuake = "Sin datos"
        }

        if (summaryData.alertInfo) {
          console.log("Han llegado datos de alertas al resumen")
          console.log(JSON.stringify(summaryData.alertInfo))
        } else {
          console.log("Sin datos de alertas")
        }
      })
      .catch(err => {
        console.log("Error recuperando resumen del análisis avanzado")
        console.log(err)
      })
    },

    getImgUrl(image) {
      if (image && image!='') {
        return require("@/assets/images/" + image);
      }else{
        return require("@/assets/images/not-found.png");
      }
    },

    showSensorModal() {
      this.modalTitle = "Sensores con alerta activa";
      this.$refs.sensorModal.show();
    },
  },
  mounted() {
    this.retrieveSummaryData()
  },
  components: {
    "spacer-card": Spacer,
    "form-input": Input,
    modal: SensorModal,
  },
};
</script>

<style scoped>
.botonAyuda {
  width: 30px;
  margin-right: 10px;
  padding: 2px;
  float: right;
  cursor: pointer;
}

.groupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 15px 15px 0px 15px;
}

.form-location-label {
  color: #606266;
}

.form-location-field-text {
  margin-left: 20px;
  font-size: 0.85rem;
}

.form-location-button {
  font-size: 12px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
